// @flow
import React from 'react';
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

const ResultBlock = styled.ul`
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 100%;
  max-height: 196px;
  -webkit-overflow-scrolling: touch;
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};
  background-color: #fff;
  white-space: nowrap;
  transform: translateY(10px);
  user-select: none;
`;

export const NoResults = styled.div`
  position: relative;
  padding: 12px 12px 12px 36px;
  ${getFont(0)};
  white-space: normal;

  svg {
    position: absolute;
    top: 15px;
    left: 9px;
    color: ${({ theme }) => theme.mainColor};
  }
`;

type Props = {
  selectedIndex: number,
  resultCount: number,
  children: any
};

export class Results extends React.Component<Props> {
  // TODO Change any for HTMLElement, and fix Flow...
  results: any;

  /* eslint-disable */
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // Auto scroll results if necessary to show selected option
    if (nextProps.selectedIndex === 0) {
      this.results.scrollTop = 0;
      return;
    }

    const itemHeight = 49;
    const itemTopPosition = nextProps.selectedIndex * itemHeight;
    const currentPosition = this.results.scrollTop + this.results.clientHeight;

    if (nextProps.selectedIndex + 1 === nextProps.resultCount) {
      this.results.scrollTop = itemTopPosition;
      return;
    }

    if (currentPosition <= itemTopPosition + itemHeight) {
      const invisibleArea = itemTopPosition + itemHeight - currentPosition;
      this.results.scrollTop += this.results.scrollTop !== nextProps.resultCount * itemHeight ? invisibleArea : 0;
      return;
    }

    if (this.results.scrollTop > itemTopPosition) {
      this.results.scrollTop = itemTopPosition;
    }
  }
  /* eslint-enable */

  render() {
    return <ResultBlock ref={el => (this.results = el)}>{this.props.children}</ResultBlock>;
  }
}
